import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { SendForSigning } from '@/views/SendForSigning/SendForSigning';
import { InsertSignature } from '@/views/InsertSignature/InsertSignature';
import { DocumentStatus } from '@/views/DocumentStatus/DocumentStatus';
function pickView() {
    const p = (typeof window !== 'undefined' ? window.location.pathname : '') || '';
    if (p.startsWith('/insert'))
        return 'insert';
    if (p.startsWith('/status'))
        return 'status';
    return 'send';
}
class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { error: null };
    }
    static getDerivedStateFromError(err) { return { error: err.message }; }
    render() {
        if (this.state.error) {
            return (_jsxs("div", { style: { padding: 20, textAlign: 'center' }, children: [_jsx("p", { style: { color: '#a4262c', fontWeight: 600 }, children: "Something went wrong" }), _jsx("p", { style: { color: '#605e5c', fontSize: 12, marginTop: 8 }, children: this.state.error }), _jsx("button", { onClick: () => window.location.reload(), style: { marginTop: 16, padding: '8px 20px', background: '#1f74f2', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }, children: "Retry" })] }));
        }
        return this.props.children;
    }
}
export function App() {
    const view = pickView();
    return (_jsx(FluentProvider, { theme: webLightTheme, children: _jsxs(ErrorBoundary, { children: [view === 'send' && _jsx(SendForSigning, {}), view === 'insert' && _jsx(InsertSignature, {}), view === 'status' && _jsx(DocumentStatus, {})] }) }));
}
